import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FundraiserHeader from "../../User/common/FundraiserHeader";
import FundraiserBodyHeader from "../../User/common/FundraiserBodyHeader";
import SubscriptionPlan from "../common/SubscriptionPlan";
import {
  getUserSubscription,
  getSubscriptionPlans,
} from "../../../services/subscriptionService";
import { setSelectedPlan } from "../../../redux/slices/subscriptionSlice";
import { setToken } from "../../../utils/connectStore";
import Loader from "../../common/Loader";
import toast from "../../../utils/toast";

const SubscriptionDetails = () => {
  const [fromApp, setFromApp] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [yearlyPlan, setYearlyPlan] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const refreshing = useSelector((state) => state.subscriptionReducer.refreshing);
  const fundraiserId = searchParams.get("fundraiserId");

  const fetchPlans = async () => {
    try {
      const subPlans = await dispatch(getSubscriptionPlans({})).unwrap();
      if (subPlans?.success === true && subPlans?.data?.length > 0) {
        const plans = Array.isArray(subPlans?.data) ? subPlans.data : [];
        const pickYearly = plans.find((p)=> String(p?.duration||"").toLowerCase().includes("year")) || plans.find((p)=> String(p?.duration||"").includes("12")) || plans[0];
        setYearlyPlan(pickYearly);
      } else {
        console.error("No subscription plans found");
        toast.error("No subscription plans available.");
      }
    } catch (error) {
      console.error("Error fetching subscription plans:", error);
      toast.error("Failed to load subscription plans. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };


  const navigation = (subscriptionData) => {
    if (subscriptionData?.length > 0) {
      navigate("/existing-subscription");
    } else {
      navigate("/fundraiser-subscription");
    }
  };

  const getImmediateExistingSub = async () => {
    
    const result = await dispatch(getUserSubscription()).unwrap();
    if (result?.success === true && result?.data?.length > 0) {
      toast.warning("You already have an active subscription!")
      navigate("/existing-subscription");
    }
  };

  useEffect(() => {
    const token = searchParams?.get("token");
    if (token !== null) {
      setFromApp(true);
      setToken(token);
      getImmediateExistingSub();
    }

    fetchPlans();
    
    // Fallback timeout to prevent infinite loading
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 5000); // 5 seconds timeout
    
    return () => clearTimeout(timeout);
  }, []);

  const handleJoinClick = async (plan) => {
    dispatch(setSelectedPlan(plan));
    if (fromApp == true) {
      const result = await dispatch(getUserSubscription()).unwrap();
      if (result?.success === true) {
        navigation(result?.data);
      }
      } else {
        if (fundraiserId !== null) {
          navigate(`/member-setup?fundraiserId=${fundraiserId}`);
        } else {
          navigate("/member-setup");
        }
      }
  };

  // When user returns from checkout/success, refresh subscription immediately
  useEffect(() => {
    const success = searchParams.get("success");
    const sessionId = searchParams.get("session_id");
    if (success === "true" || sessionId) {
      const successPath = sessionId ? `/success?session_id=${sessionId}` : "/success";
      navigate(successPath, { replace: true });
    }
    // eslint-disable-next-line
  }, []);
// When user returns from checkout/success, refresh subscription immediately
// useEffect(() => {
//   const success = searchParams.get("success");
//   const sessionId = searchParams.get("session_id");

//   if (success === "true" || sessionId) {
//     // try {
//     //   console.log("Stripe success detected — clearing onboarding data...");
//     //   const keysToClear = [
//     //     "memberSetup.email",
//     //     "memberSetup.step",
//     //     "userProfile",
//     //     "userPassword",
//     //     "memberSetup.fund",
//     //   ];
//     //   keysToClear.forEach((key) => localStorage.removeItem(key));
//     // } catch (error) {
//     //   console.warn("Cleanup failed:", error);
//     // }
//     dispatch(refreshSubscriptionStatus()).then((res) => {
//       const data = res?.payload?.data;
//       if (Array.isArray(data) && data.length > 0) {
//         navigate("/existing-subscription");
//       } else {
//         dispatch(getUserSubscription()).then((fallbackRes) => {
//           const fallbackData = fallbackRes?.payload?.data;
//           if (Array.isArray(fallbackData) && fallbackData.length > 0) {
//             navigate("/existing-subscription");
//           } else {
//             toast.info(
//               "Your subscription is being processed. Please refresh the page in a few moments."
//             );
//           }
//         });
//       }
//     });
//   }
// }, []);

  return (
    <div className="w-full h-full">
      <FundraiserHeader />
      {isLoading && <Loader />}
      {refreshing && (
        <div className="fixed top-4 right-4 bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg z-50">
          Activating your subscription...
        </div>
      )}
      {!isLoading && (
        <>
          <div className="bg-[#F4F4F4] py-10 flex flex-col items-center gap-12">
            <FundraiserBodyHeader
              heading={"Memberships"}
              content={
                "Select a Swoodle Membership and contribute 20% of the proceeds to foundation!"
              }
              contentClass={"w-[100%] sm:w-[80%] md:w-[90%] text-[#8C8C8C]"}
            />

            <div className="flex flex-col w-full items-center justify-center gap-5">
              <SubscriptionPlan
                title={yearlyPlan?.name}
                plans={yearlyPlan?.description?.split(",")}
                price={yearlyPlan?.amount}
                duration={yearlyPlan?.duration}
                joinClick={() => handleJoinClick(yearlyPlan)}
              />
            </div>
            <p className="text-[14px] sm:text-[16px] md:text-[18px] font-poppins font-[400] mt-4 text-center w-[90%]">
              By selecting a plan, you agree to our
              <span className="text-[#00ADEF] cursor-pointer" onClick={() => window.open("/privacy/toc", "_blank")}> Terms of Services </span>
              and
              <span className="text-[#00ADEF] cursor-pointer" onClick={() => window.open("/privacy/policy", "_blank")}> Privacy Policy</span>
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default SubscriptionDetails;
